import _get from 'lodash/get';

export const getPaxDeliveryError = (delivery, detectUnknownError = false) => {
  const paxDeliveryError = _get(delivery, 'paxExpressError');
  if (paxDeliveryError) {
    return paxDeliveryError;
  }

  // return unknown error if there is no quote
  if (detectUnknownError) {
    const fetchingQuote = _get(delivery, 'fetchingQuote');
    const serviceType = _get(delivery, 'detail.configuration.serviceType');
    const quoteSignature = _get(delivery, 'quote.signature');
    if (!fetchingQuote && serviceType && !quoteSignature) {
      return {
        title: 'Unknown',
        message: 'Unknown',
      };
    }
  }

  return undefined;
};

export const deliveryPriceReady = delivery => {
  const fetchingQuote = _get(delivery, 'fetchingQuote', false);
  const serviceType = _get(delivery, 'detail.configuration.serviceType');
  if (fetchingQuote || !serviceType) {
    return false;
  }

  const quoteSignature = _get(delivery, 'quote.signature');
  return !!quoteSignature;
};

export default {};
